export const MARIED_VALUE = '1'